import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody, Form, FormGroup, FormInput, Button } from 'shards-react';
import Notification from '../components/common/Notification';
import { useLocation } from 'react-router-dom';
import { confirmResetPassword, type ConfirmResetPasswordInput } from '@aws-amplify/auth';

const VerifyCode = (): React.ReactElement => {
  const { t } = useTranslation();
  const location = useLocation();
  const userEmail = location.state ? location.state.email : '';
  const [isLocked, setIsLocked] = useState<boolean>(false);
  const [formDisplay, setFormDisplay] = useState<string>('d-block');
  const [message, setMessage] = useState<string>('');
  const [code, setCode] = useState<string>('');
  const [password1, setPassword1] = useState<string>('');
  const [password2, setPassword2] = useState<string>('');

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  const handleChange = (event: React.MouseEvent<HTMLInputElement>): void => {
    const target: string = event.currentTarget.id;
    const newValue: string = event.currentTarget.value;
    switch (target) {
      case 'code':
        setCode(newValue);
        break;
      case 'password1':
        setPassword1(newValue);
        break;
      case 'password2':
        setPassword2(newValue);
        break;
      default:
        break;
    }
  };

  const validForm = (): boolean => {
    const validCode: boolean = code.length > 0;
    const validPassword1: boolean = password1.length > 0;
    const validPassword2: boolean = password2.length > 0;
    const validPassword: boolean = validPassword1 === validPassword2;
    return validCode && validPassword1 && validPassword2 && validPassword;
  };

  const handleSubmit = async (event: React.MouseEvent<HTMLInputElement>): Promise<void> => {
    event.preventDefault();
    setMessage('');
    const params: ConfirmResetPasswordInput = {
      username: userEmail,
      confirmationCode: code,
      newPassword: password2,
    };
    await confirmResetPassword(params)
      .then((data) => {
        setIsLocked(true);
        setFormDisplay('d-none');
        setMessage('パスワードがアップデートされました。ログイン画面から再度ログインして下さい。');
      })
      .catch((err) => {
        setIsLocked(false);
        setMessage(err.message);
      });
  };

  // VIEW
  // ================================================================================

  return (
    <>
      <Container fluid className="main-content-container h-100 px-4">
        <Row noGutters className="h-100">
          <Col lg="3" md="5" className="auth-form mx-auto my-auto">
            <Card>
              <CardBody>
                <div id="logo">
                  <img className="auth-form__logo d-table mx-auto mb-3" src={`${process.env.PUBLIC_URL}/images/logo_timss_long-3.png`} alt="Mill Sheet Search System - Reset Password" />
                </div>

                <Notification theme={'primary'} isOpen={message.length > 0} message={message} />

                <Form className={formDisplay}>
                  <FormGroup>
                    <label htmlFor="code">{t('login.reset.code')}</label>
                    <FormInput type="text" id="code" autoComplete="new-password" placeholder={t('login.reset.enterCode')} value={code} onChange={handleChange} disabled={isLocked} />
                  </FormGroup>
                  <FormGroup>
                    <small className="mb-3 p-3 form-text border rounded bg-light">
                      {t('login.reset.terms')}
                      <ul className="my-1 pl-4">
                        <li>{t('login.reset.term1')}</li>
                        <li>{t('login.reset.term2')}</li>
                        <li>{t('login.reset.term3')}</li>
                        <li>{t('login.reset.term4')}</li>
                      </ul>
                    </small>
                    <label htmlFor="password1">{t('login.reset.newPassword')}</label>
                    <FormInput
                      type="password"
                      id="password1"
                      autoComplete="new-password"
                      placeholder={t('login.reset.enterNewPassword')}
                      value={password1}
                      onChange={handleChange}
                      disabled={isLocked}
                    />
                    <small className="form-text text-muted text-center">{/*新しいパスワードを入力して下さい*/}</small>
                  </FormGroup>
                  <FormGroup>
                    <FormInput
                      type="password"
                      id="password2"
                      autoComplete="new-password"
                      placeholder={t('login.reset.confirmNewPassword')}
                      value={password2}
                      onChange={handleChange}
                      disabled={isLocked}
                    />
                  </FormGroup>
                  <Button pill theme="accent" className="d-table mx-auto" type="submit" onClick={handleSubmit} disabled={!validForm()}>
                    {t('login.reset.set')}
                  </Button>
                </Form>
              </CardBody>
            </Card>

            <div className="auth-form__meta d-flex mt-4">
              <Link to="/login" className="mx-auto">
                {t('login.reset.return')}
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default VerifyCode;
